import SectionCard from "components/cms/SectionCard";
import {
  AreaInput,
  CardRow,
  FieldRow,
  FileInput,
  GroupBox,
  TextInput,
} from "components/cms/fields";

const CAPS = ["cap1", "cap2", "cap3", "cap4"];
const STATS = ["stat1", "stat2"];
const WORKS = ["work1", "work2", "work3", "work4", "work5", "work6"];

const HERO_KEYS = [
  "heroBadge",
  "heroTitle",
  "heroBody",
  "heroVideoCaption",
  "heroPlayLabel",
  "heroPrimaryCtaText",
  "heroPrimaryCtaLink",
  "heroSecondaryCtaText",
  "heroSecondaryCtaLink",
  "heroImage",
  "heroHide",
];
const CAP_KEYS = [
  "capBadge",
  "capTitleLead",
  "capTitleAccent",
  "capBody",
  "cap1",
  "cap2",
  "cap3",
  "cap4",
  "capHide",
];
const COMP_KEYS = [
  "compBadge",
  "compTitleLead",
  "compTitleAccent",
  "compBody",
  "compImage",
  "stat1",
  "stat2",
  "compHide",
];
const WORK_KEYS = [
  "workTitleLead",
  "workTitleAccent",
  "workCtaText",
  "workCtaLink",
  "work1",
  "work2",
  "work3",
  "work4",
  "work5",
  "work6",
  "workHide",
];
const DEMO_KEYS = [
  "demoBadge",
  "demoTitleLead",
  "demoTitleAccent",
  "demoBody",
  "demoCtaText",
  "demoCtaLink",
  "demoHide",
];

export default function ProductsStack({
  heading,
  description,
  idPrefix,
  form,
  setField,
  frMap,
  exists,
  saveProducts,
  savingSection,
  isSectionDirty,
}) {
  return (
    <>
      <p className="mb-2 mt-6 text-sm font-semibold text-navy-700 dark:text-white">
        {heading}
      </p>
      {description ? (
        <p className="mb-3 text-xs text-gray-500">{description}</p>
      ) : null}

      <SectionCard
        title="Hero"
        hide={form.heroHide}
        hideId={`${idPrefix}-heroHide`}
        onHideChange={(value) => setField("heroHide", value)}
        onSave={() => saveProducts("hero", HERO_KEYS)}
        saving={savingSection === "hero" || savingSection === "all"}
        canSave={!exists || isSectionDirty(HERO_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Badge"
            path="heroBadge"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <AreaInput
          label="Title"
          path="heroTitle"
          form={form}
          setField={setField}
          frMap={frMap}
          rows={2}
        />
        <AreaInput
          label="Body"
          path="heroBody"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <FieldRow>
          <TextInput
            label="Video caption"
            path="heroVideoCaption"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Play button label"
            path="heroPlayLabel"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <FileInput
          label="Hero image"
          path="heroImage"
          form={form}
          setField={setField}
        />
        <FieldRow>
          <TextInput
            label="Primary CTA text"
            path="heroPrimaryCtaText"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Primary CTA link"
            path="heroPrimaryCtaLink"
            form={form}
            setField={setField}
            placeholder="/contact"
          />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Secondary CTA text"
            path="heroSecondaryCtaText"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Secondary CTA link"
            path="heroSecondaryCtaLink"
            form={form}
            setField={setField}
            placeholder="#capabilities"
          />
        </FieldRow>
      </SectionCard>

      <SectionCard
        title="Capabilities"
        hide={form.capHide}
        hideId={`${idPrefix}-capHide`}
        onHideChange={(value) => setField("capHide", value)}
        onSave={() => saveProducts("capabilities", CAP_KEYS)}
        saving={savingSection === "capabilities" || savingSection === "all"}
        canSave={!exists || isSectionDirty(CAP_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Badge"
            path="capBadge"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Title lead"
            path="capTitleLead"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Title accent"
            path="capTitleAccent"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <AreaInput
          label="Body"
          path="capBody"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <CardRow>
          {CAPS.map((key, index) => (
            <GroupBox key={key} title={`Card ${index + 1}`}>
              <TextInput
                label="Icon"
                path={`${key}.icon`}
                form={form}
                setField={setField}
                placeholder="search, shield-alert, pen, or key"
              />
              <TextInput
                label="Title"
                path={`${key}.title`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
              <AreaInput
                label="Description"
                path={`${key}.description`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
            </GroupBox>
          ))}
        </CardRow>
      </SectionCard>

      <SectionCard
        title="Compliance"
        hide={form.compHide}
        hideId={`${idPrefix}-compHide`}
        onHideChange={(value) => setField("compHide", value)}
        onSave={() => saveProducts("compliance", COMP_KEYS)}
        saving={savingSection === "compliance" || savingSection === "all"}
        canSave={!exists || isSectionDirty(COMP_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Badge"
            path="compBadge"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Title lead"
            path="compTitleLead"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Title accent"
            path="compTitleAccent"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <AreaInput
          label="Body"
          path="compBody"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <FileInput
          label="Image"
          path="compImage"
          form={form}
          setField={setField}
        />
        <CardRow>
          {STATS.map((key, index) => (
            <GroupBox key={key} title={`Stat ${index + 1}`}>
              <TextInput
                label="Value"
                path={`${key}.number`}
                form={form}
                setField={setField}
              />
              <TextInput
                label="Label"
                path={`${key}.label`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
            </GroupBox>
          ))}
        </CardRow>
      </SectionCard>

      <SectionCard
        title="Workflow"
        hide={form.workHide}
        hideId={`${idPrefix}-workHide`}
        onHideChange={(value) => setField("workHide", value)}
        onSave={() => saveProducts("workflow", WORK_KEYS)}
        saving={savingSection === "workflow" || savingSection === "all"}
        canSave={!exists || isSectionDirty(WORK_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Title lead"
            path="workTitleLead"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Title accent"
            path="workTitleAccent"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Row link text"
            path="workCtaText"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Row link"
            path="workCtaLink"
            form={form}
            setField={setField}
            placeholder="/contact"
          />
        </FieldRow>
        <CardRow>
          {WORKS.map((key, index) => (
            <GroupBox key={key} title={`Step ${index + 1}`}>
              <TextInput
                label="Number"
                path={`${key}.n`}
                form={form}
                setField={setField}
              />
              <TextInput
                label="Title"
                path={`${key}.title`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
              <AreaInput
                label="Description"
                path={`${key}.description`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
            </GroupBox>
          ))}
        </CardRow>
      </SectionCard>

      <SectionCard
        title="Demo panel"
        hide={form.demoHide}
        hideId={`${idPrefix}-demoHide`}
        onHideChange={(value) => setField("demoHide", value)}
        onSave={() => saveProducts("demo", DEMO_KEYS)}
        saving={savingSection === "demo" || savingSection === "all"}
        canSave={!exists || isSectionDirty(DEMO_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Badge"
            path="demoBadge"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Title lead"
            path="demoTitleLead"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Title accent"
            path="demoTitleAccent"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <AreaInput
          label="Body"
          path="demoBody"
          form={form}
          setField={setField}
          frMap={frMap}
        />
        <FieldRow>
          <TextInput
            label="Button text"
            path="demoCtaText"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Button link"
            path="demoCtaLink"
            form={form}
            setField={setField}
            placeholder="/contact"
          />
        </FieldRow>
      </SectionCard>
    </>
  );
}
